module.exports = __webpack_public_path__ + "img/ritz.8ecd1d0e.png";